import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../App';
import '../styles/Footer.css';

const Footer = () => {
  const { darkMode } = useTheme();
  const [showContactModal, setShowContactModal] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    subject: 'General Inquiry',
    message: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, subject, message } = contactForm;
    const mailtoBody = `Hi CardsLah Team,%0D%0A%0D%0AMy name is ${encodeURIComponent(name)}.%0D%0A%0D%0A${encodeURIComponent(message)}%0D%0A%0D%0ABest regards,%0D%0A${encodeURIComponent(name)}%0D%0A${encodeURIComponent(email)}`;
    const mailtoLink = `mailto:rey@esportslah.gg?subject=${encodeURIComponent(subject)}&body=${mailtoBody}`;
    window.location.href = mailtoLink;
    setShowContactModal(false);
    setContactForm({ name: '', email: '', subject: 'General Inquiry', message: '' });
  };

  return (
    <footer id="contact" className="footer">
      <div className="footer-content">
        <div className="footer-main">
          <div className="footer-brand">
            <div className="logo">
              <img
                src={darkMode ? "/images/cardslah-logo-dark-mode.png" : "/images/cardslah-logo.png"}
                alt="CardsLah"
                className="footer-logo-image"
              />
            </div>
            <p className="brand-tagline">
              Every Trade is a Win! Malaysia's Premier TCG Community.
            </p>
            <div className="social-links">
              <a href="https://instagram.com/cardslah" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                </svg>
              </a>
              <a href="https://tiktok.com/@cardslah" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="TikTok">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                </svg>
              </a>
              <a href="https://facebook.com/cardslah" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-links">
            <div className="links-column">
              <h4 className="column-title">QUICK LINKS</h4>
              <ul className="links-list">
                <li><a href="#home">Home</a></li>
                <li><a href="#cards">Cards</a></li>
                <li><a href="#events">Events</a></li>
                <li><a href="#about">About</a></li>
              </ul>
            </div>

            <div className="links-column">
              <h4 className="column-title">GAMES</h4>
              <ul className="links-list">
                <li><Link to="/cards?game=pokemon">Pokemon TCG</Link></li>
                <li><Link to="/cards?game=one-piece">One Piece TCG</Link></li>
                <li><Link to="/cards">Card Database</Link></li>
              </ul>
            </div>

            <div className="links-column">
              <h4 className="column-title">SUPPORT</h4>
              <ul className="links-list">
                <li><a href="#">FAQ</a></li>
                <li><a href="#">Contact Us</a></li>
                <li><a href="#">Privacy Policy</a></li>
                <li><a href="#">Terms of Service</a></li>
              </ul>
            </div>
          </div>

          <div className="footer-newsletter">
            <h4 className="newsletter-title">GET IN TOUCH!</h4>
            <p className="newsletter-text">
              Have questions, partnership inquiries, or just want to say hi?
            </p>
            <button
              onClick={() => setShowContactModal(true)}
              className="contact-email-btn"
            >
              <span className="btn-text">CONTACT US</span>
              <span className="btn-burst">!</span>
            </button>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            &copy; 2026 CardsLah. Every Trade is a Win. All rights reserved.
          </p>
          <p className="disclaimer">
            Pokemon, One Piece, Yu-Gi-Oh!, Magic: The Gathering, Digimon, and Dragon Ball are trademarks of their respective owners.
          </p>
        </div>
      </div>

      <div className="footer-decoration">
        <div className="speed-lines"></div>
      </div>

      {/* Contact Modal */}
      {showContactModal && (
        <div className="contact-modal-overlay" onClick={() => setShowContactModal(false)}>
          <div className="contact-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowContactModal(false)}>
              <span>&times;</span>
            </button>
            <div className="modal-header">
              <h3 className="modal-title">SEND US A MESSAGE<span className="title-burst">!</span></h3>
              <p className="modal-subtitle">We'd love to hear from you</p>
            </div>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Your Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={contactForm.name}
                  onChange={handleInputChange}
                  placeholder="Enter your name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Your Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={contactForm.email}
                  onChange={handleInputChange}
                  placeholder="Enter your email"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <select
                  id="subject"
                  name="subject"
                  value={contactForm.subject}
                  onChange={handleInputChange}
                >
                  <option value="General Inquiry">General Inquiry</option>
                  <option value="Partnership/Collaboration">Partnership/Collaboration</option>
                  <option value="Event Inquiry">Event Inquiry</option>
                  <option value="Feedback">Feedback</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={contactForm.message}
                  onChange={handleInputChange}
                  placeholder="Write your message here..."
                  rows="4"
                  required
                />
              </div>
              <button type="submit" className="submit-btn">
                <span className="btn-text">SEND MESSAGE</span>
                <span className="btn-burst">!</span>
              </button>
            </form>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
